// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"abb44607","207":"fa157588","242":"6f6ecbbc","410":"6fa4e048","421":"9c84db9f","477":"76bdef00","492":"54c196e0","496":"d4723ca8","650":"30f002ba","724":"11523e61","847":"d911ba13","892":"5eb29742"}[chunkId] + ".chunk.js";
};